import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTypedSelector } from 'hooks/useTypedSelector';
import './GlobalLoader.scss';
import HeatmapLoader from 'components/molecules/TuksumsMap/Sidebar/HeatmapLoader';

export const GlobalLoader = () => {
  const { isLoading, mapReady } = useTypedSelector((state) => state.global);
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (isLoading || !mapReady) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 450);
      return () => clearTimeout(timer);
    }
  }, [isLoading, mapReady]);

  // Only show the full-screen heatmap loader on the home page.
  // All other pages (forms, profile, admin, etc.) use the button spinner instead.
  if (!isVisible || location.pathname !== '/') return null;

  return (
    <div className="global-loader">
      <HeatmapLoader />
    </div>
  );
};
